
import { Card, CardContent } from '@/components/ui/card';
import { 
  CheckCircle, 
  XCircle,
  DollarSign,
  Target,
  Settings,
  Network,
  Shield,
  TrendingDown
} from 'lucide-react';

const BrokerageComparison = () => {
  const painPoints = [
    {
      icon: DollarSign,
      title: "All brokers earn only when you pay your bill",
      description: "Their incentives are aligned with your ISP, not with you"
    },
    {
      icon: TrendingDown,
      title: "Brokers earn more when your ISP charges more",
      description: "Higher bills mean higher commissions—it's that simple"
    },
    {
      icon: Target,
      title: "Many brokers push deals that don't serve the client",
      description: "Commission comes first, your actual needs come second"
    },
    {
      icon: XCircle,
      title: "They vanish after the deal closes—leaving you to figure out support alone",
      description: "Once the commission is paid, you're on your own with billing issues and outages"
    }
  ];

  const nexxDifference = [
    {
      icon: Settings,
      title: "We're not just brokers—we're a data center and solutions company",
      description: "We understand infrastructure from the ground up"
    },
    {
      icon: Network,
      title: "We design your network, not just sell you lines",
      description: "Engineering-first approach to connectivity solutions"
    },
    {
      icon: Shield,
      title: "We don't need to profit on your circuit—we make it work holistically",
      description: "Your success drives our long-term partnership"
    },
    {
      icon: TrendingDown,
      title: "We help you pay less, not more",
      description: "Because your uptime is our long-term win"
    }
  ];

  return (
    <section className="py-16 bg-gray-50 section-drift">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Why Most Brokers Get It Wrong
          </h2>
          <p className="text-xl text-gray-600">
            The industry reality vs. how we're different
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Industry Reality */}
          <div>
            <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2">
              <XCircle className="h-6 w-6" />
              The Industry Reality
            </h3>
            <div className="space-y-6">
              {painPoints.map((point, index) => (
                <Card key={index} className="border-red-200 bg-red-50/50">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="p-2 bg-red-100 rounded-lg">
                        <point.icon className="h-5 w-5 text-red-600" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">{point.title}</h4>
                        <p className="text-gray-600">{point.description}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* How We're Different */}
          <div>
            <h3 className="text-2xl font-bold text-nexx-green mb-6 flex items-center gap-2">
              <CheckCircle className="h-6 w-6" />
              How We're Different
            </h3>
            <div className="space-y-6">
              {nexxDifference.map((point, index) => (
                <Card key={index} className="border-green-200 bg-green-50/50">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="p-2 bg-green-100 rounded-lg">
                        <point.icon className="h-5 w-5 text-nexx-green" />
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">{point.title}</h4>
                        <p className="text-gray-600">{point.description}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrokerageComparison;
